<template>
    <div>
      <AllCases :emr_not_sent="emr"></AllCases>
    </div>
  </template>
    
    <script>
  import { defineAsyncComponent } from "vue";
  const AllCases = defineAsyncComponent(() =>
    import("@/components/cases/AllCases")
  );
  export default {
    components: {
      AllCases,
    },
    data() {
      return {
        emr: true,
      };
    },
  };
  </script>
    